import React from "react";
import { useLanguageContext } from "../../Context/LanguageContext";

const PrivacyDisclaimer = () => {
  const { localization } = useLanguageContext();
  return (
    <div className="info-layer-wrapper">
      <div id="privacyPolicy" style={{ display: "none" }}>
        <div className="info-dialog">
          <div className="info-content">
            <div className="info-header">
              <p className="info-title headerTitle">
                {localization.privacydisclaimer}
              </p>
            </div>
            <div className="info-body">
              <div className="container">
                <div className="row">
                  <div className="col-5">
                    <p className="headline">Graubner Industrie-Beratung GmbH</p>
                    <p style={{ whiteSpace: "nowrap" }}>
                      <strong>{localization.representBy}:</strong>
                      Sebastian Graubner
                    </p>
                    <ul>
                      {/* <li>
                    <a href='http://www.daimler.com/anbieter/' target='_blank'>
                      Rechtliche Hinweise
                    </a>
                  </li>
                  <li>
                    <a href='http://www.daimler.com/cookies/' target='_blank'>
                      Cookies
                    </a>
                  </li> */}
                      <li>
                        <a
                          href="https://graubner-gmbh.de/datenschutz"
                          target="_blank"
                        >
                          {localization.dataprotection}
                        </a>
                      </li>

                      <li>
                        <a
                          href=" https://pruefexpress.app/impressum/"
                          target="_blank"
                        >
                          {localization.imprintpage}
                        </a>
                      </li>
                    </ul>
                    <p>{localization.webVersion} PE2 23.09.05</p>
                  </div>
                  <div className="col-3"></div>
                  <div
                    className="col-4 text-right"
                    style={{ borderLeft: "2px solid black" }}
                  >
                    <p>
                      Schwimmbadstraße 26
                      <br />
                      76332 Bad Herrenalb
                      <br />
                      Deutschland
                    </p>
                    <p>
                      {localization.tel}:{" "}
                      <a href="tel:+49 800 47 28 26 3">+49 800 47 28 26 3</a>
                      <br />
                      {localization.emailID}:
                      <a href="mailto:info@graubner-gmbh.de">
                        info@graubner-gmbh.de
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="company-info">
                <p className="headline">Graubner Industrie-Beratung GmbH</p>
                <p>
                  Schwimmbadstraße 26
                  <br />
                  76332 Bad Herrenalb
                  <br />
                  Deutschland
                </p>
                <p>
                  Tel.: <a href="tel:+49 800 47 28 26 3">+49 800 47 28 26 3</a>
                  <br />
                  E-Mail:{" "}
                  <a href="mailto:info@graubner-gmbh.de">
                    info@graubner-gmbh.de
                  </a>
                </p>
              </div>
              <div className="legal-info">
                <p>
                  <strong>Vertreten durch den Vorstand:</strong> XXXX
                </p>
                <p></p>
                <p></p>
              </div> */}
            </div>
          </div>
        </div>
        <div className="text-center" style={{ fontWeight: "bold" }}>
          PrüfExpress, © 2023 Graubner Industrie-Beratung GmbH
        </div>
      </div>
    </div>
  );
};
export default PrivacyDisclaimer;
